export const ASYNC_TASK_MAP = {
  // 导入名片类型 TYPE_CARD
  2: {
    title: 'batch_import_card_title',
    success: 'batch_card_status_success',
    error: 'batch_card_status_error'
  },
  // 批量设置标签 TYPE_TAG
  3: {
    title: 'batch_add_card_title',
    success: 'batch_addtag_status_success',
    error: 'batch_addtag_status_error'
  },
  // 批量删除名片 TYPE_CARD_DELETE
  4: {
    title: 'batch_remove_card_title',
    success: 'batch_del_status_success',
    error: 'batch_item_status_error'
  },
  // 批量共享 TYPE_SHARE_WITH_OTHERS
  6: {
    title: 'batch_share_card_colleague_title',
    success: 'batch_share_status_success',
    error: 'batch_share_status_error'
  },
  // 批量更新员工
  7: {
    title: 'batch_renew_user_title'
  },
  // 批量提交精准识别
  9: {
    title: 'batch_cloudcheck_title',
    success: 'batch_cloudcheck_status_success',
    error: 'batch_cloudcheck_status_error'
  },
  // 批量导出excel
  10: {
    title: 'batch_export_contact_title',
    success: 'batch_export_contact_success',
    error: 'batch_export_contact_error'
  },
  // 批量修改创建者,导出excel
  11: {
    title: 'batch_export_creator_title',
    success: 'batch_export_creator_success',
    error: 'batch_export_creator_error'
  },
  // 批量修改创建者,导入修改后的excel
  12: {
    title: 'change_card_creator',
    success: 'manage_card_creator_finish_total',
    error: 'manage_card_creator_show_result'
  },
  // 复制到私人名片夹
  13: {
    title: 'copy_to_private_card_folder',
    success: 'copy_to_private_card_success',
    error: 'copy_to_private_status_error'
  },
  // 批量导入设备
  20: {
    title: 'batch_renew_device_title'
  },
  // 批量导入员工
  21: {
    title: 'excel_user_title'
  }
}

export const ERROR_CODE = {
  3100: 'batch_task_error_result', // 通用错误
  3101: 'batch_error_permission_denied', // 没有名片权限
  3102: 'err_cloudcheck_denied', // 无名片编辑权限
  3103: 'fast_track_exhausted', // DPS额度已用完,特殊：当为超管时，需显示fast_track_exhausted_admin_tip，并提示购买
  3104: 'excel_user_error', // 导入错误
  3105: 'err_line_limit', // 超过10000行
  3106: 'excel_header_error', // 表头错误
  3201: 'err_device_illegal', // 导入设备类型不合法
  3202: 'err_info_less', // 缺少必填信息：姓名/员工ID/初始密码
  3203: 'err_info_bad_format', // 错误的格式：员工ID/初始密码
  3204: 'payment_error_uid', // 账号无法找到
  3205: 'err_account_illegal', // 创建者账号不存在
  3206: 'excel_user_error', //  Excel导入, 单张上传错误
  3207: 'err_user_existed', // 该员工ID已经加入企业帐户
  3208: 'err_ip_exceed_limit', // 可以导入的员工数已用完
  3209: 'err_export_excel', // 导出Excel权限设置失败，填入信息不合法
  3210: 'err_save_personal', // 存入私人名片夹设置失败，填入信息不合法
  3211: 'err_superior_illegal', // 设置上司失败，上司帐户不合法
  3212: 'err_fast_track', // 精准识别张数设置失败，填入信息不合法
  3213: 'err_account', // 创建用户失败，填入的账号是无效的
  3214: 'security_device_id_null', // 设备ID不能为空
  3215: 'err_exceed_row' // 1000行
}

export const ASYNC_TASK_TYPE = {
  // 导入名片类型
  TYPE_CARD: 2,
  // 批量设置标签
  TYPE_TAG: 3,
  // 批量删除名片
  TYPE_CARD_DELETE: 4,
  // 批量复制到公司名片夹(个人版功能，企业版移除)
  TYPE_COPY_TO_CORP: 5,
  // 批量共享
  TYPE_SHARE_WITH_OTHERS: 6,
  // 批量更新员工(同步)
  TYPE_MANAGE_USER: 7,
  // 批量提交云识别
  TYPE_CLOUDCHECK: 9,
  // 批量导出excel(名片)
  TYPE_EXCEL_EXPORT: 10,
  // 批量修改创建者,导出excel
  TYPE_CREATOR_EXPORT: 11,
  // 批量修改创建者,导入修改后的excel
  TYPE_CREATOR_IMPORT: 12,
  //  复制到私人名片夹
  TYPE_COPY_TO_PRIVATE: 13,
  // 批量导入设备（同步）
  TYPE_IMPORT_DEVICE: 20,
  // 批量导入员工（同步）
  TYPE_IMPORT_MEMBER: 21
}
